import React from 'react';
import { pillars } from '../../data/mockData';
import { Sparkles, Sun, Atom, Heart } from 'lucide-react';

const iconMap = {
  Sparkles: Sparkles,
  Sun: Sun,
  Atom: Atom,
  Heart: Heart,
};

const PillarsSection = () => {
  return (
    <section className="section-padding" style={{
      background: '#0f0a1e',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
        }}>
          Our <span style={{ color: '#00d4ff' }}>Spiritual Pillars</span>
        </h2>
        <div className="section-divider" style={{ marginBottom: '60px' }} />

        <div className="grid-pillars">
          {pillars.map((pillar) => {
            const Icon = iconMap[pillar.icon];
            return (
              <div
                key={pillar.id}
                className="glass-card"
                style={{
                  padding: '40px 24px',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'rgba(139, 92, 246, 0.2)',
                  border: '1px solid rgba(139, 92, 246, 0.4)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 24px',
                }}>
                  {Icon && <Icon size={26} color="#e0dff0" />}
                </div>
                <h3 style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  marginBottom: '14px',
                  color: '#ffffff',
                }}>
                  {pillar.title}
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#b0adc0',
                  lineHeight: 1.7,
                }}>
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PillarsSection;
